const WEEKDAYS = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

/** "YYYY-MM-DD..." → Date local (sem fuso) */
export function parseDay(value) {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value || '');
  return match ? new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3])) : null;
}

/** "Seg, 03/11" (ou "Hoje, 03/11" / "Amanhã, 04/11") */
export function dayLabel(value) {
  const day = parseDay(value);
  if (!day) return '';
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const diff = Math.round((day - today) / 86400000);
  const short = `${String(day.getDate()).padStart(2, '0')}/${String(day.getMonth() + 1).padStart(2, '0')}`;
  if (diff === 0) return `Hoje, ${short}`;
  if (diff === 1) return `Amanhã, ${short}`;
  return `${WEEKDAYS[day.getDay()]}, ${short}`;
}

/** "YYYY-MM-DD HH:MM:SS" → "HH:MM" */
export function timeLabel(value) {
  const match = /[ T](\d{2}):(\d{2})/.exec(value || '');
  return match ? `${match[1]}:${match[2]}` : '';
}
